@if (isOpen) {
<div #sheetOverlay class="settings-modal-overlay" data-testid="location-settings-modal" role="dialog" aria-modal="true" aria-labelledby="settings-dialog-title"
  (click)="onBackdropClick($event)">
  <div class="settings-modal-card" (click)="$event.stopPropagation()">
    <header class="settings-modal-header">
      <div class="settings-modal-title-group">
        <span class="settings-modal-icon-badge" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path
              d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        </span>
        <div>
          <h2 id="settings-dialog-title">הגדרות עיר וסניף להשוואה</h2>
          <p class="settings-modal-subtitle">בחרו את העיר ואת הסניף הפיזי שעל פיהם תיבנה הרשימה וייבדקו המחירים.</p>
        </div>
      </div>
      <button type="button" class="settings-modal-close" data-testid="location-settings-close"
        (click)="closeModal()" aria-label="סגירת חלונית הגדרות">
        ×
      </button>
    </header>

    <div class="settings-modal-body">
      <!-- Hidden native selects for accessibility fallback & Playwright e2e test compatibility -->
      <select id="shopping-city" data-testid="shopping-city-select" [ngModel]="selectedCity"
        [ngModelOptions]="{ standalone: true }" (ngModelChange)="cityChange.emit($event)" class="sr-only" tabindex="-1"
        aria-hidden="true">
        <option value="">{{ citiesLoading ? 'טוען ערים…' : 'בחרו עיר…' }}</option>
        @for (city of cities; track city.value) {
        <option [value]="city.value">{{ city.label }}</option>
        }
      </select>

      <select id="shopping-branch" data-testid="shopping-branch-select" [ngModel]="selectedBranchId"
        [ngModelOptions]="{ standalone: true }" (ngModelChange)="branchChange.emit($event)" class="sr-only" tabindex="-1"
        aria-hidden="true">
        <option [ngValue]="null">
          {{ branchesLoading ? 'טוען סניפים…' : (selectedCity ? 'בחרו סניף פיזי…' : 'יש לבחור עיר תחילה') }}
        </option>
        @for (group of branchGroups; track group.name) {
        <optgroup [label]="group.name">
          @for (branch of group.branches; track branch.id) {
          <option [ngValue]="branch.id">
            {{ branch.chainName }} · {{ branch.branchName }}
          </option>
          }
        </optgroup>
        }
      </select>

      <!-- City Autocomplete Combobox -->
      <div class="settings-field city-combobox-wrap" [class.is-open]="cityMenuOpen">
        <label class="settings-field-label" for="shopping-city-input">
          עיר להשוואה <strong aria-hidden="true">*</strong>
        </label>
        <div class="settings-combo-control" [class.has-focus]="cityMenuOpen"
          [class.is-disabled]="citiesLoading || cities.length === 0">
          <input id="shopping-city-input" type="text" class="settings-combo-input" data-testid="shopping-city-input"
            [ngModel]="citySearchQuery" (input)="onCityInput($any($event.target).value)" (focus)="openCityMenu()"
            (click)="openCityMenu()" (keydown)="onCityKeydown($event)"
            [placeholder]="citiesLoading ? 'טוען ערים…' : 'בחרו או הקלידו שם עיר…'"
            [disabled]="citiesLoading || cities.length === 0" autocomplete="off" dir="rtl" role="combobox"
            aria-autocomplete="list" [attr.aria-expanded]="cityMenuOpen" aria-controls="city-suggestions-list" />
          <div class="settings-combo-actions">
            @if (citySearchQuery && !citiesLoading) {
            <button type="button" class="settings-combo-btn settings-combo-clear" (click)="clearCitySelection($event)"
              aria-label="נקה בחירת עיר" title="נקה">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            }
            @if (citiesLoading) {
            <span class="settings-combo-spinner" aria-hidden="true"></span>
            }
            <button type="button" class="settings-combo-btn settings-combo-chevron" [class.is-open]="cityMenuOpen"
              (click)="toggleCityMenu($event)" [disabled]="citiesLoading || cities.length === 0"
              aria-label="פתח או סגור רשימת ערים" tabindex="-1">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2"
                stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
          </div>
        </div>

        @if (cityMenuOpen) {
        <ul id="city-suggestions-list" class="settings-combo-dropdown" role="listbox">
            @if (filteredCities.length === 0) {
            <li class="settings-combo-empty" role="presentation">
              לא נמצאו ערים מתאימות לחיפוש
            </li>
            }
            @for (city of filteredCities; track city.value; let i = $index) {
            <li id="city-opt-{{ i }}" class="settings-combo-option" [class.is-selected]="city.value === selectedCity"
              [class.is-active]="i === activeCityIndex" (mousedown)="selectCity(city)" role="option"
              [attr.aria-selected]="city.value === selectedCity">
              <span class="settings-combo-option-text">{{ city.label }}</span>
              @if (city.value === selectedCity) {
              <svg class="settings-combo-check" viewBox="0 0 24 24" width="16" height="16" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              }
            </li>
            }
        </ul>
        }
      </div>

      <!-- Branch Autocomplete Combobox -->
      <div class="settings-field branch-combobox-wrap" [class.is-open]="branchMenuOpen">
        <label class="settings-field-label" for="shopping-branch-input">
          סניף לבניית הרשימה <strong aria-hidden="true">*</strong>
        </label>
        <div class="settings-combo-control" [class.has-focus]="branchMenuOpen"
          [class.is-disabled]="!selectedCity || branchesLoading || branches.length === 0">
          <input id="shopping-branch-input" type="text" class="settings-combo-input"
            data-testid="shopping-branch-input" [ngModel]="branchSearchQuery"
            (input)="onBranchInput($any($event.target).value)" (focus)="openBranchMenu()" (click)="openBranchMenu()"
            (keydown)="onBranchKeydown($event)"
            [placeholder]="branchesLoading ? 'טוען סניפים…' : (selectedCity ? 'בחרו או הקלידו שם סניף או רשת…' : 'יש לבחור עיר תחילה')"
            [disabled]="!selectedCity || branchesLoading || branches.length === 0" autocomplete="off" dir="rtl"
            role="combobox" aria-autocomplete="list" [attr.aria-expanded]="branchMenuOpen"
            aria-controls="branch-suggestions-list" />
          <div class="settings-combo-actions">
            @if (branchSearchQuery && !branchesLoading && selectedCity) {
            <button type="button" class="settings-combo-btn settings-combo-clear"
              (click)="clearBranchSelection($event)" aria-label="נקה בחירת סניף" title="נקה">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            }
            @if (branchesLoading) {
            <span class="settings-combo-spinner" aria-hidden="true"></span>
            }
            <button type="button" class="settings-combo-btn settings-combo-chevron" [class.is-open]="branchMenuOpen"
              (click)="toggleBranchMenu($event)"
              [disabled]="!selectedCity || branchesLoading || branches.length === 0"
              aria-label="פתח או סגור רשימת סניפים" tabindex="-1">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2"
                stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
          </div>
        </div>

        @if (branchMenuOpen) {
        <ul id="branch-suggestions-list" class="settings-combo-dropdown" role="listbox">
            @if (filteredBranches.length === 0) {
            <li class="settings-combo-empty" role="presentation">
              לא נמצאו סניפים מתאימים לחיפוש
            </li>
            }
            @for (branch of filteredBranches; track branch.id; let i = $index) {
            <li id="branch-opt-{{ i }}" class="settings-combo-option settings-branch-option"
              [class.is-selected]="branch.id === selectedBranchId" [class.is-active]="i === activeBranchIndex"
              (mousedown)="selectBranch(branch)" role="option" [attr.aria-selected]="branch.id === selectedBranchId">
              <div class="settings-branch-option-content">
                @if (iconFor(branch); as icon) {
                <span class="settings-branch-mark">
                  <img [src]="icon" [alt]="branch.chainName" />
                </span>
                }
                <span class="settings-branch-text">
                  <span class="settings-branch-name">{{ branch.branchName }}</span>
                  @if (branch.address?.trim()) {
                  <span class="settings-branch-address">{{ branch.address }}</span>
                  }
                </span>
              </div>
              @if (branch.id === selectedBranchId) {
              <svg class="settings-combo-check" viewBox="0 0 24 24" width="16" height="16" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              }
            </li>
            }
        </ul>
        }
      </div>

      @if (branches.length > 0) {
      <p class="settings-branches-info">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"
          aria-hidden="true">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        <span>נמצאו {{ branches.length }} סניפים פיזיים ב{{ selectedCityLabel }}.</span>
      </p>
      }
    </div>

    <footer class="settings-modal-footer">
      <button type="button" class="settings-btn-cancel" (click)="closeModal()">
        סגור
      </button>
      <button type="button" class="primary settings-save-btn" data-testid="location-settings-confirm"
        (click)="closeModal()" [disabled]="!selectedBranchId">
        אישור והמשך
      </button>
    </footer>
  </div>
</div>
}
